import React from "react";

const FacebookIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"><path d="M34 17a17 17 0 1 0-17 17l.3-.007v-13.228h-3.654v-4.256h3.654v-3.135c0-3.632 2.218-5.611 5.459-5.611a29.669 29.669 0 0 1 3.274.166v3.8h-2.233c-1.76 0-2.105.837-2.105 2.065v2.706h4.217l-.551 4.257h-3.666v12.586a17.005 17.005 0 0 0 12.305-16.343z" fill={props.fill}/></svg>
    )
}

export default FacebookIcon;
